import React, { PropTypes } from 'react'
import TextField from 'material-ui/TextField'
import { grey500 } from 'material-ui/styles/colors'
import set from 'lodash/set'
import get from 'lodash/get'
import sessionSaleTypes from '../../fieldOptions/sessionSaleTypes'

const inputs = sessionSaleTypes.map(type => ({
  label: type.name,
  prop: `session_reservations.${type.value}`
}))

const styles = {
  wrapper: {
    clear: 'both'
  },
  label: {
    color: grey500,
    fontSize: '1em',
    paddingTop: '15px',
    display: 'block'
  }
}

const LegacyStatsField = ({ label, value, onChange }) => {
  const handleChange = (event, input, val) => {
    set(value, input.prop, val)
    onChange(event, value)
  }

  return (
    <div style={styles.wrapper}>
      <label style={styles.label}>{label}</label>
      {
        inputs.map(input => (
          <TextField
            key={input.label}
            type='number'
            floatingLabelText={input.label}
            onChange={(e, val) => {
              e.preventDefault()
              handleChange(e, input, val)
            }}
            value={get(value, input.prop, 0)}
          />
        ))
      }
    </div>
  )
}

// @ts-ignore
LegacyStatsField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired
}

export default LegacyStatsField
